import { API_ENDPOINTS } from '../config/api';
import { runCachedRequest } from '../_helpers/requestCache';

export const regionConstants = {
  REGIONS_FETCH_REQUEST: 'REGIONS_FETCH_REQUEST',
  REGIONS_FETCH_SUCCESS: 'REGIONS_FETCH_SUCCESS',
  REGIONS_FETCH_FAILURE: 'REGIONS_FETCH_FAILURE',
};

function regionsRequest() {
  return { type: regionConstants.REGIONS_FETCH_REQUEST };
}

function regionsSuccess(regions) {
  return { type: regionConstants.REGIONS_FETCH_SUCCESS, regions };
}

function regionsFailure(error) {
  return { type: regionConstants.REGIONS_FETCH_FAILURE, error };
}

export function regionsFetchData() {
  return async (dispatch) => {
    dispatch(regionsRequest());
    
    const user = JSON.parse(localStorage.getItem('user'));
    const headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${user.token}`
    };

    try {
      const response = await runCachedRequest(
        'regions:all',
        () => fetch(API_ENDPOINTS.REGION.ALL, {
          method: 'GET',
          headers,
        }),
        { ttl: 5 * 60 * 1000 },
      );

      if (!response.ok) {
        throw Error(response.statusText);
      }

      const regions = await response.json();
      dispatch(regionsSuccess(regions));
      return regions;
    } catch (error) {
      dispatch(regionsFailure(error.message));
      throw error;
    }
  };
}
